import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../API/axiosInstance";
import "./../styles/SignInSplit.css";
import { generateHash } from "../API/hashUtil";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { AuthBrandPanel, ArrowLeft, ArrowRight } from "./SignInSplit";

const PasswordRequestPage = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const disableRightClick = (e) => {
      e.preventDefault();
    };
    document.addEventListener("contextmenu", disableRightClick);
    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address.", {
        position: "top-right",
        autoClose: 5000,
      });
      setIsSubmitting(false);
      return;
    }

    const stringParams = {
      email: email ? email.toString() : "",
    };
    const hexHash = generateHash(stringParams);

    try {
      // Use api (axios) — baseURL is already set, don't prepend apiUrl again
      const response = await api.post("/password/request", null, {
        params: {
          email: email,
          HPPcode: hexHash,
        },
      });

      if (response.status === 200) {
        toast.success(
          "If the email exists, a password reset link has been sent.",
          { position: "top-right", autoClose: 5000 },
        );
      }
      setEmail("");
    } catch (error) {
      if (error.response) {
        if (error.response.status === 429) {
          toast.error("Too many reset requests. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
          });
        } else {
          // Don't reveal whether user exists or not
          toast.error("An error occurred. Please try again.", {
            position: "top-right",
            autoClose: 5000,
          });
        }
      } else {
        toast.error("Network error. Please check your connection.", {
          position: "top-right",
          autoClose: 5000,
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="csp">
      {/* ══════════ LEFT — navy panel ══════════ */}
      <AuthBrandPanel />

      {/* ══════════ RIGHT — form panel ══════════ */}
      <section className="csp-panel">
        <Link to="/" className="csp-back">
          <ArrowLeft />
          Back
        </Link>

        <div className="csp-form-wrap">
          <div className="csp-head">
            <h2 className="csp-title">Forgot Password</h2>
            <p className="csp-sub">
              A recovery password will be sent to your email
            </p>
          </div>

          <form className="csp-form" onSubmit={handleSubmit}>
            <div className="csp-field">
              <label htmlFor="email" className="csp-label">
                Email Address
              </label>
              <div className="csp-input-wrap">
                <input
                  className="csp-input csp-input--icon-end"
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="yourname@company.com"
                  required
                  autoComplete="email"
                />
                <FontAwesomeIcon icon={faEnvelope} className="csp-input-icon" />
              </div>
            </div>

            <button
              type="submit"
              className={`csp-submit${isSubmitting ? " is-submitting" : ""}`}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending…" : "Send Recovery Email"}
              {!isSubmitting && <ArrowRight />}
            </button>

            <p className="csp-foot">
              Remember your password? <Link to="/">Sign In</Link>
            </p>
          </form>
        </div>
      </section>
    </div>
  );
};

export default PasswordRequestPage;
